import './styles/tokens.css';
import './styles/site.css';

import { h } from './components/dom';
import { Ticker } from './components/ticker';
import { Nav } from './components/nav';
import { Hero } from './components/hero';
import { Marquee } from './components/marquee';
import { Work } from './components/work';
import { Stack } from './components/stack';
import { Process } from './components/process';
import { Contact } from './components/contact';
import { Footer } from './components/footer';

import { showCurtain } from './effects/curtain';
import { splitToLetters, revealLetters } from './effects/letterReveal';
import { setupCursor } from './effects/cursor';
import { setupParallax } from './effects/parallax';
import { setupScrollReveal } from './effects/scrollReveal';
import { setupNavBackdrop } from './effects/navBackdrop';
import { setupProximitySnap } from './effects/proximitySnap';
import { setupHeroScene } from './effects/heroScene';

const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function mount() {
  const app = document.getElementById('app');
  if (!app) throw new Error('#app element missing');

  app.append(
    Ticker(),
    Nav(),
    h('main', { id: 'main' },
      Hero(),
      Marquee(),
      Work(),
      Stack(),
      Process(),
      Contact(),
    ),
    Footer(),
  );
}

function revealHeroSurroundings(delayMs = 800, stepMs = 80) {
  const els = document.querySelectorAll<HTMLElement>(
    '.s-hero__tag, .s-hero__numbers, .s-hero__lede, .s-hero__cta-row, .s-hero__corner',
  );
  els.forEach((el, i) => {
    el.classList.add('fx-reveal');
    setTimeout(() => el.classList.add('in'), delayMs + i * stepMs);
  });

  const canvas = document.querySelector<HTMLElement>('.fx-hero-canvas');
  if (canvas) setTimeout(() => canvas.classList.add('in'), 600);
}

async function bootEffects() {
  // pre-split the hero title BEFORE the curtain lifts so the staggered
  // start state isn't visible mid-load
  const title = document.querySelector('.s-hero__title');
  const letters = title ? splitToLetters(title) : [];

  setupCursor();
  setupNavBackdrop();
  setupScrollReveal();

  if (reducedMotion) {
    // no curtain, no parallax, no three.js — just snap content visible
    letters.forEach((el) => el.classList.add('in'));
    document.querySelectorAll<HTMLElement>(
      '.s-hero__tag, .s-hero__numbers, .s-hero__lede, .s-hero__cta-row, .s-hero__corner',
    ).forEach((el) => { el.classList.add('fx-reveal', 'in'); });
    return;
  }

  setupParallax();
  setupProximitySnap();
  setupHeroScene();

  const { finish } = showCurtain();
  // begin the reveal as soon as the curtain starts lifting
  revealLetters(letters);
  revealHeroSurroundings();
  await finish;
}

function boot() {
  mount();
  void bootEffects();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot);
} else {
  boot();
}
